import { PropsWithChildren } from "react";
import { StudentFormData, useStudentForm } from "../StudentDataFormProvider";
import { Stack, styled, Typography } from "@mui/material";

type Props = {
  fieldName: keyof StudentFormData;
  label?: string;
  maxLength?: number;
  required?: boolean;
};

export const LongTextField = ({
  fieldName,
  label,
  maxLength = 100,
  required = false,
}: PropsWithChildren<Props>) => {
  const {
    register,
    formState: { errors },
  } = useStudentForm();
  return (
    <Stack gap={"0.25rem"}>
      {label && <label htmlFor={fieldName}>{label}</label>}
      <StyledInput rows={4} style={{ width: "auto" }} {...register(fieldName, { required, maxLength })} />
      {errors[fieldName] && (
        <Typography variant="caption" sx={{ color: "red" }}>
          This field is required
        </Typography>
      )}
    </Stack>
  );
};

const StyledInput = styled("textarea")({
  borderRadius: "0.5rem",
  padding: "0.5rem",
  border: "1px solid #cbcbcb",
  fontSize: "1rem",
  maxWidth: "100%",
  minWidth: "100%",
});
